<template>
	<modal
		class="contact-form-modal"
		size="medium"
		:hide-footer="true"
		v-if="show"
		@close="close">
		<div slot="header">
			<h3><b>{{ $t('_.tags') }}</b></h3>
		</div>
		<div slot="body">
			<form class="order-edit-form" @submit.prevent="submitTag">
				<div class="container-fluid mt-4">
					<div class="row">
						<div class="col-sm-12">
							<!-- tag name -->
							<div class="form-group mb-2">
								<label><b>Tags</b></label>
								<tags-select
									:max="5"
									v-model="tagLists"
									@add="createTag">
								</tags-select>
							</div>
						</div>
					</div>
					<div class="row modal-footer mt-4">
						<div class="col-sm-12 px-0">
							<button class="btn btn-light" v-on:click.stop.prevent="close">{{ $t('global.close') }}</button>
							<button class="btn btn-primary" type="submit" :class="{ 'is-loading': isSaving }">{{ $t('global.save') }}</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</modal>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from './Modal.vue';
import TagsSelect from './TagsSelect.vue';
import { duplicateVar } from '../lib/helper';
import submissionsApi from '../api/submissions';
import tagApi from '../api/tag';

export default {
	components: {
		Modal,
		TagsSelect,
	},
	props: {
		selectedTags: {
			type: Array,
			default: () => [],
		},
		show: {
			type: Boolean,
			default: false,
		},
		tagType: {
			type: String,
		},
		tagData: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			isUploading: false,
			isSaving: false,
			selectedId: '',
			selectedIds: [],
			tagLists: [],
			verifiedTag: false,
			searchKeyword: '',
		};
	},
	computed: {
		...mapGetters({
			tags: 'submissions/tags',
		}),
	},
	created() {
	},
	methods: {
		...mapActions({
			setAppendTag: 'submissions/setAppendTag',
			updatedSubmissionTag: 'submissions/updatedSubmissionTag',
			updatedSubmissionsTag: 'submissions/updatedSubmissionsTag',
		}),

		// init
		init() {
			this.selectedIds = this.tagData.map(el => el._id);
			const tags = this.tagData && this.tagData[0] && this.tagData[0].tags ? this.tagData[0].tags : [];
			this.tagLists = tags.map(el => ({ name: el }));
		},

		// close
		close() {
			this.clearFormFields();
			this.$emit('close');
		},

		// on select input tag
		select(tag) {
			const newTag = duplicateVar(tag);
			this.tagLists = [...this.tagLists, newTag];
		},

		// on add tag
		add(newTag) {
			const tag = { name: newTag };
			this.tagLists = [...this.tagLists, tag];
			this.createTag(newTag);
		},

		// create tag
		createTag(name) {
			const params = {
				name,
				category: 'order',
			};

			// eslint-disable-next-line
			const callback = (response) => {
				const name = response.data.name;
				const tag = { name };
				this.setAppendTag(tag);
			};

			const errorCallback = (err) => {
				// eslint-disable-next-line
				console.log('err tag', err);
			};

			tagApi.store(params, callback, errorCallback);
		},

		// submit
		submitTag() {
			this.isSaving = true;
			const tags = this.tagLists.map(el => el.name);
			const params = {
				submission_ids: JSON.stringify(this.selectedIds),
				tags: JSON.stringify(tags),
			};

			// eslint-disable-next-line
			const callback = (response) => {
				const data = {
					ids: this.selectedIds,
					tags,
				};
				this.updatedSubmissionsTag(data);
				this.close();
				this.notify({
					title: 'orders',
					text: 'Orders tag updated',
					type: 'success',
				});
				this.showModal = false;
				this.isSaving = false;
			};

			const errorCallback = (err) => {
				const message = err.response.data.message;
				this.notify({
					title: 'orders',
					text: message,
					type: 'error',
				});
				this.isSaving = false;
			};

			submissionsApi.updateTag(params, callback, errorCallback);
		},

		// toast notification
		notify(params) {
			this.$notify({
				group: 'contacts',
				title: params.title,
				text: params.text,
				type: params.type,
			});
		},

		// clear fields
		clearFormFields() {
			this.selectedId = '';
			this.selectedIds = [];
			this.tagLists = [];
		},
	},
	watch: {
		show(show) {
			if (show) {
				this.init();
			}
		},
	},
};
</script>
<style scoped>
.is-error {
	color: red;
}

.form-error {
	border-color: red;
}

.input-group .input-group-prepend .multiselect__tags {
	background-color: #fff !important;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}
</style>
